import { render } from "./Gallery.vue?vue&type=template&id=ba1a2d8c"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=ba1a2d8c&lang=css"
script.render = render

export default script